import {
  createPlugin,
  createComponentExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const apiGatewayPlugin = createPlugin({
  id: 'api-gateway',
  routes: {
    root: rootRouteRef,
  },
});

/** @public */
export const EntityAPIGatewayCard = apiGatewayPlugin.provide(
  createComponentExtension({
    name: 'EntityAPIGatewayCard',
    component: {
      lazy: () =>
        import('./components/ApiGatewayCard').then(m => m.ApiGatewayCard),
    },
  }),
);
